import { useNavigate } from 'react-router';
import { LoadingState } from '@/components/common';
import { useCurrentUser } from '@/contexts';
import { ProfilePage } from './ProfilePage';

export function MyProfilePage() {
  const navigate = useNavigate();
  const { currentUser: profile } = useCurrentUser();

  if (!profile) return <LoadingState />;

  return <ProfilePage user={profile} isOwn onBack={() => navigate('/account')} />;
}
